module.exports = __webpack_public_path__ + "static/media/outro_2.c299e0cd.mp3";